const alreadyCitysScores = [8, 8, 5, 4, 5, 7, 4, 1, 4, 5, 5, 4, 7, 1, 2, -2, -2, -4, -4, 4, 3, 5, 5, 4];

export default alreadyCitysScores;
